import { render, staticRenderFns } from "./DesignComponentsForm.vue?vue&type=template&id=3e1f79f1&scoped=true"
import script from "./DesignComponentsForm.vue?vue&type=script&lang=js"
export * from "./DesignComponentsForm.vue?vue&type=script&lang=js"
import style0 from "./DesignComponentsForm.vue?vue&type=style&index=0&id=3e1f79f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1f79f1",
  null
  
)

/* custom blocks */
import block0 from "./DesignComponentsForm.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports